import type { SoftwareUpdatesNode } from '@schema';
import { groupBy } from 'lodash-es';

export default function deduplicateVersions(versions: SoftwareUpdatesNode['available_storage_release']): SoftwareUpdatesNode['available_storage_release'] {
  const groups = groupBy(versions, item => `${item.version}-${item.release}`);

  return Object.values(groups).map(group => {
    const rebootRequired = group.find(g => g.reboot_required);
    if (rebootRequired) {
      return rebootRequired;
    }

    const maintenanceRequired = group.find(g => g?.maintenance && Object.values(g.maintenance).some(Boolean));
    if (maintenanceRequired) {
      return maintenanceRequired;
    }

    return group[0];
  });
}
